import { isArray, isRegExp, isString } from 'lodash';

function safeDecodeURIComponent(str) {
  try {
    return decodeURIComponent(str);
  } catch {
    return str;
  }
}

/**
 * Get the value of a URL search parameter by key, array of keys, or regex.
 * Parses location.search (or searchString when provided); returns the first match for array/regex, or null if not found.
 * @param {string|string[]|RegExp} paramKey - Exact key, array of keys (first match wins), or regex to match key
 * @param {string} [searchString] - Optional query string (e.g. '?a=1&b=2'). When omitted, uses location.search.
 * @returns {string|null} The parameter value or null
 */
export function getUrlSearchParams(paramKey, searchString) {
  const search = searchString !== undefined ? searchString : (typeof location !== 'undefined' ? location.search : '');
  const params = search
    .replace(/^\?/, '')
    .split('&')
    .filter((segment) => segment.length > 0)
    .map((line) => {
      const [rawKey, rawValue] = line.split('=');
      const key = rawKey != null ? safeDecodeURIComponent(rawKey) : '';
      const value = rawValue !== undefined ? safeDecodeURIComponent(rawValue) : '';
      return { key, value };
    });
  if (isString(paramKey)) {
    return params.find((param) => param.key === paramKey)?.value ?? null;
  }
  if (isArray(paramKey)) {
    for (const key of paramKey) {
      const value = getUrlSearchParams(key, search);
      if (value != null) return value;
    }
    return null;
  }
  if (isRegExp(paramKey)) {
    const found = params.find((param) => paramKey.test(param.key));
    return found != null ? found.value : null;
  }
  return null;
}
